import { createSlice } from "@reduxjs/toolkit";
import { SignUp } from "services/user/user.service";
import { toast } from 'react-toastify';

export const registrationSlice = createSlice({
  name: "registration",
  initialState: {
    registration: {},
    registrationLoading: false,
    registrationError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(SignUp.pending, (state) => {
      state.registrationLoading = true
    });

    builder.addCase(SignUp.fulfilled, (state, action) => {

      state.registration = action.payload
      state.registrationLoading = false
      state.registrationError = null
    });

    builder.addCase(SignUp.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! Something went wrong during registration 😣")

      state.registrationLoading = false
      state.registrationError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});